import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'p8-settings-footer',
  templateUrl: './settings-footer.component.html',
  styleUrls: ['./settings-footer.component.scss']
})
export class SettingsFooterComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
